<div [class.is-open]="!isCollapsed" class="sb-grid-filter background-color-regular border-color-regular">
  <div
    class="sb-grid-filter--item direction-flex codere-icon"
    (click)="toggle()"
    [class.icon-arrow-right]="!blocked"
    #content
  >
    <div class="sb-grid-filter--icons">
      <span *ngIf="!!currentEvent?.StreamingEnabled && showIcon" class="sb-grid-filter--streaming has-streaming"></span>
      <div class="sb-grid-filter--icon">
        <img
          class="sb-grid-filter--icon-image"
          src="assets/global/img/banderas/ICO_{{currentEvent?.CountryCode}}.png"
          alt=""
        />
      </div>
    </div>
    <p class="sb-grid-filter--title color-dark" *ngIf="currentEvent?.Name">
      {{ currentEvent?.Name | translate }}
      <span *ngIf="currentEvent?.StartDate" class="sb-grid-filter--subtitle color-muted"
        >({{ currentEvent?.StartDate | sportsExtractHour }})</span
      >
    </p>

    <p class="sb-grid-filter--title color-dark" *ngIf="currentEvent?.value">{{ currentEvent?.text | translate }}</p>
  </div>
  <div class="sb-grid-filter--content background-color-base" #content>
    <ng-content></ng-content>
  </div>
</div>
